import { Facebook, Twitter, Instagram, Youtube, Linkedin, Music2, type LucideIcon } from 'lucide-react';

// Social profiles are not yet active - set to true when profiles are built
export const SOCIAL_PROFILES_ACTIVE = false;

// TikTok profile URL for QR codes (canonical URL without tracking params)
export const TIKTOK_PROFILE_URL = 'https://www.tiktok.com/@elefaconnect';

export interface SocialProfile {
  handle: string;
  url: string;
  displayName: string;
  icon: LucideIcon;
}

export const SOCIAL_PROFILES = {
  twitter: {
    handle: '@ElefaMobile',
    url: 'https://twitter.com/elefamobile',
    displayName: 'Twitter / X',
    icon: Twitter,
  },
  linkedin: {
    handle: 'elefa-mobile',
    url: 'https://linkedin.com/company/elefa-mobile',
    displayName: 'LinkedIn',
    icon: Linkedin,
  },
  facebook: {
    handle: 'elefamobile',
    url: 'https://facebook.com/elefamobile',
    displayName: 'Facebook',
    icon: Facebook,
  },
  instagram: {
    handle: 'elefamobile',
    url: 'https://instagram.com/elefamobile',
    displayName: 'Instagram',
    icon: Instagram,
  },
  youtube: {
    handle: '@elefamobile',
    url: 'https://youtube.com/@elefamobile',
    displayName: 'YouTube',
    icon: Youtube,
  },
  tiktok: {
    handle: '@elefaConnect',
    url: 'https://www.tiktok.com/@elefaconnect',
    displayName: 'TikTok',
    icon: Music2,
  },
} as const;

// TikTok bio link for investor funnel - use this in TikTok profile
export const TIKTOK_BIO_LINK = 'https://elefa.tel/tiktok-investor?utm_source=tiktok&utm_medium=profile&utm_campaign=investor';

// Alternative consumer funnel link
export const TIKTOK_CONSUMER_LINK = 'https://elefa.tel/tiktok?utm_source=tiktok&utm_medium=profile&utm_campaign=organic';

export const SHARE_MESSAGES = {
  waitlistReferral: {
    title: 'Join elefa - International calling, made simple',
    text: "I joined elefa's waitlist - low-cost international calls and top-ups to 195 countries. Get 20% off your first 3 months!",
    hashtags: ['ElefaMobile', 'InternationalCalling', 'CheapCalls', 'VoIP'],
  },
  planShare: {
    title: 'elefa Mobile - Plans with international calling included',
    text: "Check out elefa - mobile plans with unlimited national calls plus low-cost international calling built in.",
    hashtags: ['ElefaMobile', 'MVNO', 'InternationalCalling'],
  },
  connectShare: {
    title: 'elefa Connect - Call any phone, anywhere',
    text: "Call any phone number in 195 countries with elefa Connect. Purchased credit never expires.",
    hashtags: ['ElefaConnect', 'InternationalCalling', 'CallAnywhere', 'VoIP'],
  },
  elefaInvite: {
    text: 'WhatsApp works when everyone has internet.\n\nElefa works when they only have a phone number.\n\nCall family directly. No app required on their side.',
    url: 'https://elefa.tel',
  },
} as const;

// Helper to get social profiles as array for mapping
// Returns empty array when social profiles are not yet active
export const getSocialProfilesArray = () => 
  SOCIAL_PROFILES_ACTIVE ? [
    SOCIAL_PROFILES.facebook,
    SOCIAL_PROFILES.twitter,
    SOCIAL_PROFILES.linkedin,
    SOCIAL_PROFILES.instagram,
    SOCIAL_PROFILES.youtube,
    SOCIAL_PROFILES.tiktok,
  ] : [];
